import React, { PureComponent } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';

export interface MaskProps {
  /**
   * zIndex值
   */
  zIndex?: number;
  /**
   * 背景颜色
   */
  backgroundColor?: string;
  /**
   * 自定义样式
   */
  style?: ViewStyle;
}

/**
 * 遮罩
 */
export default class Mask extends PureComponent<MaskProps> {
  render() {
    const { style, zIndex = 10, backgroundColor = 'rgba(0,0,0,0.7),' } = this.props;

    return <View style={[styles.container, { zIndex, backgroundColor }, style]}>{this.props.children}</View>;
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
